import { render, staticRenderFns } from "./orderSettlement.vue?vue&type=template&id=0f316c8c&scoped=true"
import script from "./orderSettlement.vue?vue&type=script&lang=js"
export * from "./orderSettlement.vue?vue&type=script&lang=js"
import style0 from "./orderSettlement.vue?vue&type=style&index=0&id=0f316c8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f316c8c",
  null
  
)

export default component.exports